import Chip from '@mui/material/Chip'
import type { AttributeChip } from 'helpers/appliedSettingValues.helper/appliedSettingValues.types'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type AppliedSettingPropertyChipsProps = {
  chips: AttributeChip[]
  selectedAttributes: string[]
  onToggle: (attribute: string) => void
  onClear: () => void
}

export function AppliedSettingPropertyChips({
  chips,
  selectedAttributes,
  onToggle,
  onClear,
}: AppliedSettingPropertyChipsProps): ReactNode {
  const { t } = useTranslation()
  const isNarrowed = selectedAttributes.length > 0

  return (
    <div role="group" aria-label={t('Filter by property')} className="flex flex-wrap gap-1 pl-2.5">
      <Chip
        label={t('Show all properties')}
        size="small"
        clickable
        aria-pressed={!isNarrowed}
        color={isNarrowed ? 'default' : 'primary'}
        onClick={onClear}
      />
      {chips.map(({ attribute, title }) => {
        const isSelected = selectedAttributes.includes(attribute)
        return (
          <Chip
            key={attribute}
            label={t(title)}
            size="small"
            clickable
            aria-pressed={isSelected}
            color={isSelected ? 'primary' : 'default'}
            onClick={() => onToggle(attribute)}
          />
        )
      })}
    </div>
  )
}
